import { showEmeraldDialog } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { popEmeraldModal } from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { store } from 'src/common/redux/configure-store';
import { MICRActions } from 'src/common/redux/reducers/micr-reducer';
import {
  getTriButtonModalBottom,
  TriButtonModalBottomProps,
} from 'src/home-page/components/finish-transaction/tender-refund-message';
import { CheckEndorsementViewProps } from '../components/check-processing-types';
import { closePrintEndorsementView } from '../components/print-endorsement-view';
import { goToManualEntryEndorsement } from './handle-print-endorsement';

const ENDORSEMENT_MODAL_ID = 'endorsement-tender-modal';

export const showEndorsementModal = async (
  screenData: CheckEndorsementViewProps,
  onlyShowBack?: boolean,
): Promise<void> => {
  return new Promise<void>(resolve => {
    const modalMessage = 'HeaderControlCheckEndorsement';

    const modalSubMessage = 'CheckEndorsementErrorMessage';

    const onClose = () => {
      closePrintEndorsementView();
      popEmeraldModal(ENDORSEMENT_MODAL_ID);
      store.dispatch(MICRActions.resetMICRData());
      resolve();
    };

    const onRetry = () => {
      popEmeraldModal(ENDORSEMENT_MODAL_ID);
      resolve();
    };

    const onManual = () => {
      goToManualEntryEndorsement(screenData, onlyShowBack);
      popEmeraldModal(ENDORSEMENT_MODAL_ID);
      resolve();
    };

    const triButtonModalBottomProps: TriButtonModalBottomProps = {
      closeButton: {
        label: 'ButtonCancelStyle_Cancel',
        onClick: onClose,
      },
      middleButton: {
        label: 'MANUAL',
        onClick: onManual,
      },
      rightButton: {
        label: 'RETRY',
        onClick: onRetry,
      },
    };

    const endorsementModal: IMessageModal = {
      message: modalMessage,
      type: EmeraldDialogTypes.Error,
      subMessage: modalSubMessage,
      buttonComponent: getTriButtonModalBottom(triButtonModalBottomProps),
      disableBackdropClick: true,
      modalId: ENDORSEMENT_MODAL_ID,
    };

    showEmeraldDialog(endorsementModal);
  });
};
